import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import DescriptionAIDisclaimer from './DescriptionAIDisclaimer';
import DescriptionEmptyState from './DescriptionEmptyState';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentDescriptionPanel = ({
  deckId,
  description,
  title,
  toggleDocumentDescription
}) => {
  const {
    isLoading,
    isUserEdited,
    hasError,
    text: descriptionText
  } = description;
  const renderTitle = () => {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockEnd: "400",
      alignItems: "center",
      justifyContent: "space-between",
      children: /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "200",
        inlineSize: "250px",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          overflowWrap: "break-word",
          children: title
        })
      })
    });
  };
  const renderBody = () => {
    if (hasError) {
      return /*#__PURE__*/_jsx(ErrorMessage, {
        type: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.description.loadingError"
        })
      });
    }
    if (!descriptionText) {
      return /*#__PURE__*/_jsx(DescriptionEmptyState, {
        deckId: deckId
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: descriptionText
      }), /*#__PURE__*/_jsx(DescriptionAIDisclaimer, {
        isUserEdited: isUserEdited
      })]
    });
  };
  return /*#__PURE__*/_jsxs(Panel, {
    width: 350,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "description-panel-close-button",
      onClick: () => toggleDocumentDescription({
        isOpen: false
      })
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.description.title"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        overflow: "hidden",
        children: [isLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
          "data-test-id": "description-panel-loader",
          grow: true,
          minHeight: 200,
          layout: "centered"
        }), !isLoading && /*#__PURE__*/_jsxs(_Fragment, {
          children: [renderTitle(), renderBody()]
        })]
      })
    })]
  });
};
export default DocumentDescriptionPanel;